/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ObservableMap } from "mobx";

import { EntityMapState } from "./EntityMapState";

/**
 * Creates a state for storing each entity by their unique identifier in a map when using generic store.
 * @template TKey The type of the unique identifier for each entity.
 * @template TEntity The type of the entity value.
 * @returns The created state for storing each entity by their unique identifier in a map when using generic store.
 */
export function createEntityMapState<TKey, TEntity>(): EntityMapState<TKey, TEntity> {
    return {
        valuesByIds: new ObservableMap<TKey, TEntity>()
    };
}
